import { graphql, type Environment, commitMutation } from 'react-relay';
import serverVars from 'server-vars';
import { USER_EVENT_TYPE } from './constants';

import { getPageId, getTruncatedPdpPageId, getUserData } from './helpers';
import {
    type trackUserEventMutation,
    type UserTrackingMutationInput,
} from './__generated__/trackUserEventMutation.graphql';

const mutation = graphql`
    mutation trackUserEventMutation($input: UserTrackingMutationInput!) {
        userTrackingMutation(input: $input) {
            __typename
        }
    }
`;

type TrackUserInput = Omit<UserTrackingMutationInput, 'userId' | 'sessionId'>;

const trackUserEvent = (environment: Environment, { pageId, ...input }: TrackUserInput): void => {
    const isBotDetected = serverVars.get('btdtctd');
    if (isBotDetected === 'true') {
        return;
    }
    commitMutation<trackUserEventMutation>(environment, {
        mutation,
        variables: { input: { ...getUserData(), ...input, pageId: pageId || getPageId() } },
    });
};

export const trackUserEventSearch = (environment: Environment, searchQuery: string): void =>
    trackUserEvent(environment, {
        eventType: USER_EVENT_TYPE.SEARCH,
        searchQuery,
    });

export const trackUserEventHomepageView = (environment: Environment): void =>
    trackUserEvent(environment, { eventType: USER_EVENT_TYPE.HOMEPAGE_VIEW });

export const trackUserEventItemPageView = (
    environment: Environment,
    items: UserTrackingMutationInput['items']
): void =>
    trackUserEvent(environment, {
        eventType: USER_EVENT_TYPE.ITEM_PAGE_VIEW,
        pageId: getTruncatedPdpPageId(),
        items,
    });

export const trackUserEventPageView = (environment: Environment): void =>
    trackUserEvent(environment, { eventType: USER_EVENT_TYPE.PAGE_VIEW });

export const trackUserEventAddToCart = (
    environment: Environment,
    items: UserTrackingMutationInput['items']
): void =>
    trackUserEvent(environment, {
        eventType: USER_EVENT_TYPE.ADD_TO_CART,
        pageId: getTruncatedPdpPageId(),
        items,
    });

export const trackUserEventItemAddToFavorites = (
    environment: Environment,
    items: UserTrackingMutationInput['items']
): void =>
    trackUserEvent(environment, {
        eventType: USER_EVENT_TYPE.ADD_TO_FAVORITES,
        pageId: getTruncatedPdpPageId(),
        items,
    });

export const trackUserEventCheckout = (
    environment: Environment,
    items: UserTrackingMutationInput['items']
): void =>
    trackUserEvent(environment, {
        eventType: USER_EVENT_TYPE.CHECKOUT,
        items,
    });
